export const PLATFORMS: Array<string> = ['ps5', 'ps4', 'xbox', 'nintendo', 'nintendo2'];
